module.exports = __webpack_public_path__ + "img/h3-3.28113ff3.png";